import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error("Supabase environment variables are missing!");
}

export const supabase = createClient(
    supabaseUrl,
    supabaseAnonKey,
    {
        db: {
            schema: 'espuma',
        },
        realtime: {
            log_level: 'error',
        }
    }
);

export default supabase;
